const ossApi = '/ossApi'
const encryptionJS = require('../../assets/js/encryption');
// 唐山人大正式版
let tenantCode = '130200000000000001'
let title = '唐山市'
let imageUrl = ossApi + '/130200'
let username = encryptionJS.aesDecrypt('22BGmn1pszrnJBSilKnsTA==')
let password = encryptionJS.aesDecrypt('65DQ19IWzgEgSSfwqVNXrQ==')
let serviceUrl = 'http://111.63.4.38:8000/tssrd'  //履职服务平台

switch (process.env.NODE_ENV) {
  case 'development': // 开发环境
    // 测试
    tenantCode = '130200000000000001'
    title = '唐山市'
    imageUrl = ossApi + '/130200'
    username = encryptionJS.aesDecrypt('22BGmn1pszrnJBSilKnsTA==')
    password = encryptionJS.aesDecrypt('65DQ19IWzgEgSSfwqVNXrQ==')
    serviceUrl = 'http://111.63.4.38:8000/tssrd'
    break
  default:
    break
}
export default {
  ossApi,
  tenantCode,
  title,
  imageUrl,
  username,
  password,
  serviceUrl
}
